export const returnErrorOrDefaultMessage = (err : any, defaultMessage:string) => {
    if(err?.response?.data?.message){
        return err.response.data.message as string;
    } return defaultMessage;
}